export default __webpack_public_path__ + "static/media/user_permission.0e608910.svg";